module.exports = __webpack_public_path__ + "static/media/header-popup-img.f6284e3f.jpg";